<template>
  <div class="presupuesto-gastos-datos">
    <b-row>
      <b-col cols="12" xl="12">  
        <b-card header="Datos del Presupuesto">
            <b-table 
                class="datos-objeto"
                responsive="sm" 
                :busy="tableBusy"
                :items="datos" 
                :fields="campos">
              <template v-slot:cell(valor)="data">
                {{ formattedData(data.item) }}
              </template>
              <div slot="table-busy" class="text-center">
                <b-spinner class="table-spinner" label="Spinning" />
              </div>              
            </b-table>
        </b-card>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="12" xl="12">  
        <b-card header="Renglones">
          <b-table 
              small 
              responsive="sm"
              class="registro-ordenes" 
              :items="renglonesDatos" 
              :fields="fields">
            <template v-slot:cell(importe)="data">
              {{ data.item.importe | moneda }}
            </template>
          </b-table>
          <b-table 
              small 
              responsive="sm"
              class="registro-ordenes totales"
              :items="totales" 
              :fields="totalesFields">
            <template v-slot:cell(importe)="data">
              {{ data.item.importe | moneda }}
            </template>
          </b-table>
        </b-card>
      </b-col>
    </b-row>

    <div class="fixed-btn">
      <div class="list-dropdown-btn">
        <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
          <template slot="button-content">
            <i class="fa fa-ellipsis-v fa-2x" aria-hidden="true"></i>
          </template>
          
          <!-- <b-dropdown-item @click.stop="editar">
            <i class="fa fa-edit"></i>Editar Datos del Concepto</b-dropdown-item> -->

          <b-dropdown-item @click.stop="goBack">
            <i class="fa fa-undo"></i>Volver al Listado</b-dropdown-item>
        </b-dropdown>
      </div>
    </div>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'presupuestoGastos/getField',
  mutationType: 'presupuestoGastos/updateField',
});

export default {
  name: 'PresupuestoGastosData',
  components: {
    appMensaje: Mensaje,
  },
  mixins: [ 
    msjModal, 
  ],
  data: () => {
    return {
      id: 0,
      campos: [
        {key: 'campo'},
        {key: 'valor'},
      ],

      fields: [
        {
          key: 'presupuestoGastosConcepto',
          label: 'Concepto'
        },
        {
          key: 'importe',
          label: 'Importe',
          class: 'text-right'
        },
      ],

      totalesFields: [
        { key: 'blank_0'},
        { key: 'importe', class: "text-right"}
      ],

      tableBusy: false,
    }
  },
  computed: {
    ...mapFields([
      'datos',
      'renglonesDatos'
    ]),
    totales() {
      let totalPresupuesto = this.renglonesDatos.reduce((total, renglon) => {
            return total + parseFloat(renglon.importe);
        }, 0);

      return [{
        importe: totalPresupuesto
      }];
    }
  },  
  created() {
    this.id= this.$route.params.id
    
    this.tableBusy = true;
    this.$store.dispatch('presupuestoGastos/getDatos', this.id)
      .then(() => this.tableBusy = false)
      .catch(error => this.showErrorMsj(error));
  },  
  methods: {
    goBack() {
      this.$router.push({ name: 'PresupuestosGastos' }); 
    },
    editar() {
      this.$router.push({ name: 'PresupuestoGastosEdit', 
                          params: { id: this.id }})
    },
  }
}
</script>

<style>
  .presupuesto-gastos-datos .registro-ordenes table td {
    vertical-align: middle;
    border: none;
  }
  .presupuesto-gastos-datos .registro-ordenes table td[aria-colindex="1"] {
    width: 80%;
  }
  .presupuesto-gastos-datos .registro-ordenes table td[aria-colindex="2"] {
    width: 20%;
  }
  .presupuesto-gastos-datos .registro-ordenes.totales table {
    margin-bottom: 0;
  }
  .presupuesto-gastos-datos .registro-ordenes.totales table th {
    display: none;
  }
  .presupuesto-gastos-datos .registro-ordenes.totales table tr {
    font-size: 1.2em;
  }

</style>
